export enum BrandStatus {
  ACTIVE = 'Active',
  DEACTIVE = 'Deactive'
}

export type TBrand = {
  id: string;
  name: string;
  email: string;
  address: string;
  phone: string;
  picUrl: string;
  status: BrandStatus;
  numberOfStores: number;
};

export type TNewBrandCreate = {
  name: string;
  email: string;
  address: string;
  phone: string;
  picUrl: string;
  brandCode: string;
};

export type TBrandUpdate = TNewBrandCreate;

export type TBrandDetail = TBrand;

export type TUiConfigPayload = {
  primaryColor?: string;
  secondaryColor?: string;
  textColor?: string;
  surfaceColor?: string;
};

export type TStoreUiConfigResponse = {
  id: string;
  brandId: string;
  code?: string;
  name?: string;
  shortName?: string;
  displayName?: string;
  brandPicUrl?: string;
  logoUrl?: string;
  primaryColor?: string;
  secondaryColor?: string;
  textColor?: string;
  surfaceColor?: string;
  hasStoreOverride: boolean;
};
